import lodash from "lodash";

import { correctBoolean } from "../locations/data";

const dropdowns = {
  poolType: {
    key: "pool_type",
    data: {
      "Indoor Pool": 1,
      "Indoor Spa": 2,
      "Outdoor Pool": 3,
      "Outdoor Spa": 4
    }
  },
  increaseChlorineChemical: {
    key: "increase_chlorine_chemical",
    data: {
      "Chlorine Gas": 1,
      "Calcium Hypochlorite (67%)": 2,
      "Sodium Hypochlorite (12%)": 3,
      "Lihium Hypochlorite": 4,
      "Dichlor (62%)": 5,
      "Dichlor (56%)": 6,
      Trichlor: 7
    }
  },
  increaseTotalAlkalinityChemical: {
    key: "increase_total_alkalinity_chemical",
    data: {
      "Sodium Bicarbonate": 1,
      "Sodium Carbonate": 2,
      "Sodium Sesquicarbonate": 3
    }
  },
  decreaseTotalAlkalinityChemical: {
    key: "decrease_total_alkalinity_chemical",
    data: {
      "Muriatic Acid (31.4%)": 1,
      "Sodium Bisulfate": 2
    }
  },
  increaseCalciumHardnessChemical: {
    key: "increase_calcium_hardness_chemical",
    data: {
      "Calcium Chloride (100%)": 1,
      "Calcium Chloride (77%)": 2
    }
  },
  increaseStabilizerChemical: {
    key: "increase_stabilizer_chemical",
    data: {
      "Cyanuric Acid": 1
    }
  },
  neutralizeChlorineChemical: {
    key: "neutralize_chlorine_chemical",
    data: {
      "Sodium Thiosulfate Acid": 1,
      "Sodium Sulfite": 2
    }
  }
};

const colHeaders = [
  "ID",
  "Location *",
  "Name *",
  "Type",
  "Notes",
  "Volume (gal)",
  "Free Chlorine Visible",
  "Free Chlorine Low Alert (ppm)",
  "Free Chlorine High Alert (ppm)",
  "Total Chlorine Visible",
  "Total Chlorine Low Alert (ppm)",
  "Total Chlorine High Alert (ppm)",
  "Total Bromine Visible",
  "Total Bromine Low Alert (ppm)",
  "Total Bromine High Alert (ppm)",
  "pH Visible",
  "pH Low Alert",
  "pH High Alert",
  "Pool Temp Visible",
  "Ideal Pool Temperature",
  "Pool Temp Low Alert (F)",
  "Pool Temp High Alert (F)",
  "Inc. Chlorine Chemical",
  "Inc. Total Alkalinity Chemical",
  "Dec. Total Alkalinity Chemical",
  "Inc. Calcium Hardness Chemical",
  "Inc. Stabilizer Chemical",
  "Neutralize Chlorine Chemical",
  "HRR / ORP Visible",
  "Alkalinity Visible",
  "Calcium Hardness Visible",
  "Air Temp Visible",
  "Water Clarity Visible",
  "Backwash Visible",
  "Notes Visible",
  "Custom Field One Name",
  "Custom Field Two Name",
  "Custom Field Three Name",
  "Custom Field Four Name",
  "Custom Field Five Name",
  "Custom Field Six Name",
  "Custom Field Seven Name",
  "Custom Field Eight Name",
  "Custom Field Nine Name",
  "Custom Field Ten Name",
  "Custom Field Eleven Name",
  "Custom Field Twelve Name"
];

const columns = locations => {
  return [
    {
      data: "id",
      type: "text",
      readOnly: true
    },
    {
      data: "locationName",
      type: "dropdown",
      source: _.map(_.sortBy(locations, ["name"]), "name")
    },
    {
      data: "name",
      type: "text"
    },
    {
      data: "poolType",
      type: "dropdown",
      source: Object.keys(dropdowns.poolType.data)
    },
    {
      data: "notes",
      type: "text"
    },
    {
      data: "volume",
      type: "numeric"
    },
    {
      data: "free_chlorine_ppm_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "free_chlorine_ppm_low_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "free_chlorine_ppm_high_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "total_chlorine_ppm_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "total_chlorine_ppm_low_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "total_chlorine_ppm_high_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "total_bromine_ppm_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "total_bromine_ppm_low_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "total_bromine_ppm_high_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "ph_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "ph_low_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "ph_high_alert",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "pool_temp_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "ideal_pool_temp",
      type: "numeric",
      format: "0.0"
    },
    {
      data: "pool_temp_low_alert",
      type: "numeric",
      format: "0.00"
    },
    {
      data: "pool_temp_high_alert",
      type: "numeric",
      format: "0.00"
    },
    {
      data: "increaseChlorineChemical",
      type: "dropdown",
      source: Object.keys(dropdowns.increaseChlorineChemical.data),
      strict: true
    },
    {
      data: "increaseTotalAlkalinityChemical",
      type: "dropdown",
      source: Object.keys(dropdowns.increaseTotalAlkalinityChemical.data),
      strict: true
    },
    {
      data: "decreaseTotalAlkalinityChemical",
      type: "dropdown",
      source: Object.keys(dropdowns.decreaseTotalAlkalinityChemical.data),
      strict: true
    },
    {
      data: "increaseCalciumHardnessChemical",
      type: "dropdown",
      source: Object.keys(dropdowns.increaseCalciumHardnessChemical.data),
      strict: true
    },
    {
      data: "increaseStabilizerChemical",
      type: "dropdown",
      source: Object.keys(dropdowns.increaseStabilizerChemical.data),
      strict: true
    },
    {
      data: "neutralizeChlorineChemical",
      type: "dropdown",
      source: Object.keys(dropdowns.neutralizeChlorineChemical.data),
      strict: true
    },

    {
      data: "hrr_orp_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "alkalinity_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "calcium_hardness_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "air_temp_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "water_clarity_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "backwash_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "notes_toggle",
      type: "dropdown",
      source: ["Yes", "No"]
    },
    {
      data: "custom_field_one_name",
      type: "text"
    },
    {
      data: "custom_field_two_name",
      type: "text"
    },
    {
      data: "custom_field_three_name",
      type: "text"
    },
    {
      data: "custom_field_four_name",
      type: "text"
    },
    {
      data: "custom_field_five_name",
      type: "text"
    },
    {
      data: "custom_field_six_name",
      type: "text"
    },
    {
      data: "custom_field_seven_name",
      type: "text"
    },
    {
      data: "custom_field_eight_name",
      type: "text"
    },
    {
      data: "custom_field_nine_name",
      type: "text"
    },
    {
      data: "custom_field_ten_name",
      type: "text"
    },
    {
      data: "custom_field_eleven_name",
      type: "text"
    },
    {
      data: "custom_field_twelve_name",
      type: "text"
    }
  ];
};

const colWidths = [
  1,
  250,
  150,
  150,
  400,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  180,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125,
  125
];

const correctFields = (locations, data) => {
  return lodash.map(data, item => {
    const location = lodash.find(locations, { id: item.location_id });
    item.locationName = location && location.name;

    Object.keys(dropdowns).forEach(key => {
      const k = item[dropdowns[key].key];
      item[key] = lodash.invert(dropdowns[key].data)[k];
    });

    return item;
  });
};

const compareNamesWithIds = (data, locations) =>
  lodash.map(data, item => {
    let prevRecord;
    let newRecord;
    if (item[1] === "locationName") {
      const prevLocation = lodash.find(locations, {
        name: item[2]
      });
      const newLocation = lodash.find(locations, {
        name: item[3]
      });

      prevRecord = prevLocation && prevLocation.id;
      newRecord = newLocation && newLocation.id;
      item[1] = "location_id";
    } else if (dropdowns[item[1]]) {
      const dropdown = dropdowns[item[1]];

      prevRecord = dropdown.data[item[2]];
      newRecord = dropdown.data[item[3]];
      item[1] = dropdown.key;
    }

    if (prevRecord) {
      item[2] = prevRecord;
    }
    if (newRecord) {
      item[3] = newRecord;
    }

    return item;
  });

const compareNamesWithIdsImporter = (data, locations) =>
  lodash.map(data, item => {
    if (item["locationName"]) {
      const newLocation = lodash.find(locations, {
        name: item["locationName"]
      });

      if (newLocation) {
        delete item["locationName"];
        item["location_id"] = newLocation.id;
      }
    }

    Object.keys(item).forEach(key => {
      if (dropdowns[key]) {
        const dropdown = dropdowns[key];
        item[dropdown.key] = dropdown.data[item[key]];
        delete item[key];
      }
    });

    return correctBoolean(item, true);
  });

export {
  colHeaders,
  columns,
  colWidths,
  correctFields,
  compareNamesWithIds,
  compareNamesWithIdsImporter
};
